export default "__VITE_ASSET__CRxbdVCD__"